// ============================================
// STAFF & HR TEST DATA
// Realistic employee data for all outlets
// ============================================

export const roles = [
  { id: 'gm', name: 'General Manager', nameNo: 'Daglig leder', level: 1, permissions: ['all'] },
  { id: 'rm', name: 'Restaurant Manager', nameNo: 'Restaurantsjef', level: 2, permissions: ['pos', 'inventory', 'hr', 'reports'] },
  { id: 'am', name: 'Assistant Manager', nameNo: 'Assisterende leder', level: 3, permissions: ['pos', 'inventory', 'hr'] },
  { id: 'hc', name: 'Head Chef', nameNo: 'Kjøkkensjef', level: 3, permissions: ['pos', 'inventory', 'kitchen'] },
  { id: 'sc', name: 'Sous Chef', nameNo: 'Souschef', level: 4, permissions: ['pos', 'inventory', 'kitchen'] },
  { id: 'chef', name: 'Chef', nameNo: 'Kokk', level: 5, permissions: ['pos', 'kitchen'] },
  { id: 'server', name: 'Server', nameNo: 'Servitør', level: 6, permissions: ['pos'] },
  { id: 'bartender', name: 'Bartender', nameNo: 'Bartender', level: 6, permissions: ['pos', 'bar'] },
  { id: 'host', name: 'Host', nameNo: 'Hovmester', level: 6, permissions: ['pos', 'reservations'] },
  { id: 'runner', name: 'Food Runner', nameNo: 'Matbærer', level: 7, permissions: ['pos'] },
  { id: 'dishwasher', name: 'Dishwasher', nameNo: 'Oppvasker', level: 7, permissions: [] },
];

export const employmentTypes = [
  { id: 'fulltime', name: 'Full-time', nameNo: 'Heltid', hoursPerWeek: 37.5 },
  { id: 'parttime', name: 'Part-time', nameNo: 'Deltid', hoursPerWeek: null },
  { id: 'oncall', name: 'On-call', nameNo: 'Tilkalling', hoursPerWeek: null },
  { id: 'seasonal', name: 'Seasonal', nameNo: 'Sesong', hoursPerWeek: null },
];

// Staff members - Sørengkaia, Oslo
export const staff = [
  // ===== SØRENGKAIA, OSLO (24 staff) =====
  {
    id: 'emp-001',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-001',
    firstName: 'Erik',
    lastName: 'Andersen',
    email: 'erik.andersen@isfco.no',
    phone: '+47 912 34 567',
    role: 'gm',
    employmentType: 'fulltime',
    department: 'management',
    startDate: '2018-05-01',
    salary: { amount: 720000, currency: 'NOK', period: 'yearly' },
    bankAccount: '1234.56.78901',
    taxCard: 'hovedkort',
    emergencyContact: { name: 'Marte Andersen', phone: '+47 987 65 432', relation: 'spouse' },
    certifications: ['food-safety', 'alcohol-service', 'first-aid'],
    isActive: true,
    avatar: null,
  },
  {
    id: 'emp-002',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-002',
    firstName: 'Line',
    lastName: 'Johansen',
    email: 'line.johansen@isfco.no',
    phone: '+47 923 45 678',
    role: 'rm',
    employmentType: 'fulltime',
    department: 'management',
    startDate: '2018-06-15',
    salary: { amount: 580000, currency: 'NOK', period: 'yearly' },
    certifications: ['food-safety', 'alcohol-service', 'first-aid'],
    isActive: true,
  },
  {
    id: 'emp-003',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-003',
    firstName: 'Magnus',
    lastName: 'Berg',
    email: 'magnus.berg@isfco.no',
    phone: '+47 934 56 789',
    role: 'am',
    employmentType: 'fulltime',
    department: 'management',
    startDate: '2019-02-01',
    salary: { amount: 480000, currency: 'NOK', period: 'yearly' },
    certifications: ['food-safety', 'alcohol-service'],
    isActive: true,
  },
  {
    id: 'emp-004',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-004',
    firstName: 'Rajesh',
    lastName: 'Kumar',
    email: 'rajesh.kumar@isfco.no',
    phone: '+47 945 67 890',
    role: 'hc',
    employmentType: 'fulltime',
    department: 'kitchen',
    startDate: '2018-05-01',
    salary: { amount: 520000, currency: 'NOK', period: 'yearly' },
    certifications: ['food-safety', 'haccp'],
    isActive: true,
  },
  {
    id: 'emp-005',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-005',
    firstName: 'Priya',
    lastName: 'Sharma',
    email: 'priya.sharma@isfco.no',
    phone: '+47 956 78 901',
    role: 'sc',
    employmentType: 'fulltime',
    department: 'kitchen',
    startDate: '2019-08-01',
    salary: { amount: 420000, currency: 'NOK', period: 'yearly' },
    certifications: ['food-safety'],
    isActive: true,
  },
  {
    id: 'emp-006',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-006',
    firstName: 'Amit',
    lastName: 'Patel',
    email: 'amit.patel@isfco.no',
    phone: '+47 967 89 012',
    role: 'chef',
    employmentType: 'fulltime',
    department: 'kitchen',
    startDate: '2020-03-01',
    salary: { amount: 380000, currency: 'NOK', period: 'yearly' },
    certifications: ['food-safety'],
    isActive: true,
  },
  {
    id: 'emp-007',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-007',
    firstName: 'Kari',
    lastName: 'Olsen',
    email: 'kari.olsen@isfco.no',
    phone: '+47 978 90 123',
    role: 'server',
    employmentType: 'fulltime',
    department: 'service',
    startDate: '2019-04-01',
    salary: { amount: 195, currency: 'NOK', period: 'hourly' },
    certifications: ['alcohol-service'],
    isActive: true,
  },
  {
    id: 'emp-008',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-008',
    firstName: 'Thomas',
    lastName: 'Hansen',
    email: 'thomas.hansen@isfco.no',
    phone: '+47 989 01 234',
    role: 'server',
    employmentType: 'parttime',
    department: 'service',
    startDate: '2021-08-15',
    salary: { amount: 185, currency: 'NOK', period: 'hourly' },
    certifications: ['alcohol-service'],
    isActive: true,
  },
  {
    id: 'emp-009',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-009',
    firstName: 'Ingrid',
    lastName: 'Larsen',
    email: 'ingrid.larsen@isfco.no',
    phone: '+47 990 12 345',
    role: 'bartender',
    employmentType: 'fulltime',
    department: 'bar',
    startDate: '2020-06-01',
    salary: { amount: 200, currency: 'NOK', period: 'hourly' },
    certifications: ['alcohol-service', 'bartender-cert'],
    isActive: true,
  },
  {
    id: 'emp-010',
    outletId: 'no-sorengkaia',
    employeeNumber: 'NO-010',
    firstName: 'Sofia',
    lastName: 'Nilsen',
    email: 'sofia.nilsen@isfco.no',
    phone: '+47 901 23 456',
    role: 'host',
    employmentType: 'parttime',
    department: 'service',
    startDate: '2022-01-10',
    salary: { amount: 180, currency: 'NOK', period: 'hourly' },
    certifications: [],
    isActive: true,
  },

  // ===== FROGNER, OSLO (18 staff - sample) =====
  {
    id: 'emp-020',
    outletId: 'no-frogner',
    employeeNumber: 'NO-020',
    firstName: 'Kristian',
    lastName: 'Svendsen',
    email: 'kristian.svendsen@isfco.no',
    phone: '+47 912 00 001',
    role: 'rm',
    employmentType: 'fulltime',
    department: 'management',
    startDate: '2019-09-01',
    salary: { amount: 560000, currency: 'NOK', period: 'yearly' },
    certifications: ['food-safety', 'alcohol-service', 'first-aid'],
    isActive: true,
  },
  {
    id: 'emp-021',
    outletId: 'no-frogner',
    employeeNumber: 'NO-021',
    firstName: 'Anita',
    lastName: 'Haugen',
    email: 'anita.haugen@isfco.no',
    phone: '+47 912 00 002',
    role: 'hc',
    employmentType: 'fulltime',
    department: 'kitchen',
    startDate: '2019-09-15',
    salary: { amount: 500000, currency: 'NOK', period: 'yearly' },
    certifications: ['food-safety', 'haccp'],
    isActive: true,
  },

  // ===== HAMMARBY SJÖSTAD, STOCKHOLM (22 staff - sample) =====
  {
    id: 'emp-040',
    outletId: 'se-hammarby',
    employeeNumber: 'SE-040',
    firstName: 'Anna',
    lastName: 'Lindqvist',
    email: 'anna.lindqvist@isfstockholm.se',
    phone: '+46 70 123 45 67',
    role: 'rm',
    employmentType: 'fulltime',
    department: 'management',
    startDate: '2018-03-15',
    salary: { amount: 52000, currency: 'SEK', period: 'monthly' },
    certifications: ['food-safety', 'alcohol-service'],
    isActive: true,
  },
  {
    id: 'emp-041',
    outletId: 'se-hammarby',
    employeeNumber: 'SE-041',
    firstName: 'Vikram',
    lastName: 'Singh',
    email: 'vikram.singh@isfstockholm.se',
    phone: '+46 70 234 56 78',
    role: 'hc',
    employmentType: 'fulltime',
    department: 'kitchen',
    startDate: '2018-03-20',
    salary: { amount: 48000, currency: 'SEK', period: 'monthly' },
    certifications: ['food-safety'],
    isActive: true,
  },

  // ===== SOLNA (20 staff - sample) =====
  {
    id: 'emp-060',
    outletId: 'se-solna',
    employeeNumber: 'SE-060',
    firstName: 'Johan',
    lastName: 'Eriksson',
    email: 'johan.eriksson@isfsolna.se',
    phone: '+46 70 345 67 89',
    role: 'rm',
    employmentType: 'fulltime',
    department: 'management',
    startDate: '2020-06-01',
    salary: { amount: 50000, currency: 'SEK', period: 'monthly' },
    certifications: ['food-safety', 'alcohol-service', 'first-aid'],
    isActive: true,
  },
];

// Shifts schedule - sample week
export const shifts = [
  // Monday - Sørengkaia
  { id: 'shift-001', outletId: 'no-sorengkaia', employeeId: 'emp-002', date: '2025-01-27', startTime: '10:00', endTime: '18:00', role: 'rm', status: 'scheduled' },
  { id: 'shift-002', outletId: 'no-sorengkaia', employeeId: 'emp-004', date: '2025-01-27', startTime: '09:00', endTime: '17:00', role: 'hc', status: 'scheduled' },
  { id: 'shift-003', outletId: 'no-sorengkaia', employeeId: 'emp-005', date: '2025-01-27', startTime: '14:00', endTime: '22:00', role: 'sc', status: 'scheduled' },
  { id: 'shift-004', outletId: 'no-sorengkaia', employeeId: 'emp-007', date: '2025-01-27', startTime: '11:00', endTime: '19:00', role: 'server', status: 'scheduled' },
  { id: 'shift-005', outletId: 'no-sorengkaia', employeeId: 'emp-008', date: '2025-01-27', startTime: '16:00', endTime: '23:00', role: 'server', status: 'scheduled' },
  { id: 'shift-006', outletId: 'no-sorengkaia', employeeId: 'emp-009', date: '2025-01-27', startTime: '16:00', endTime: '23:00', role: 'bartender', status: 'scheduled' },
];

// Time-off requests
export const timeOffRequests = [
  {
    id: 'pto-001',
    employeeId: 'emp-007',
    employeeName: 'Kari Olsen',
    outletId: 'no-sorengkaia',
    type: 'vacation',
    startDate: '2025-02-10',
    endDate: '2025-02-14',
    days: 5,
    status: 'pending',
    requestedDate: '2025-01-20',
    reason: 'Vinterferie',
    approver: null,
  },
  {
    id: 'pto-002',
    employeeId: 'emp-008',
    employeeName: 'Thomas Hansen',
    outletId: 'no-sorengkaia',
    type: 'sick',
    startDate: '2025-01-24',
    endDate: '2025-01-24',
    days: 1,
    status: 'approved',
    requestedDate: '2025-01-24',
    reason: 'Syk',
    approver: 'emp-002',
    approvedDate: '2025-01-24',
  },
  {
    id: 'pto-003',
    employeeId: 'emp-041',
    employeeName: 'Vikram Singh',
    outletId: 'se-hammarby',
    type: 'vacation',
    startDate: '2025-03-01',
    endDate: '2025-03-07',
    days: 5,
    status: 'pending',
    requestedDate: '2025-01-15',
    reason: 'Familjebesök i Indien',
    approver: null,
  },
];

// Helper functions
export const getStaffByOutlet = (outletId) => staff.filter(s => s.outletId === outletId);
export const getStaffById = (id) => staff.find(s => s.id === id);
export const getActiveStaff = () => staff.filter(s => s.isActive);
export const getStaffByRole = (roleId) => staff.filter(s => s.role === roleId);
export const getShiftsByOutlet = (outletId, date) => shifts.filter(s => s.outletId === outletId && s.date === date);
export const getPendingTimeOff = () => timeOffRequests.filter(r => r.status === 'pending');
